import { Injectable } from "@angular/core";
import { TimeagoCustomFormatter, TimeagoIntl } from "ngx-timeago";
import { LocalStorage } from "./localstorage.helper";


@Injectable()
export class MyTimeagoFormatter extends TimeagoCustomFormatter {
    constructor(intl: TimeagoIntl) {
        super(intl);
    }

    override format(then: number): string {
        const now = Date.now();
        const diffMs = now - then;
        const diffMinutes = diffMs / 1000 / 60;
        const lang = LocalStorage.get('lang') || 'en';
        if (diffMinutes < 2) {
            return lang === 'ar' ? 'الآن' : 'Now';
        }
        return super.format(then);
    }
}
